<script setup lang="ts">

import Translator from "@/utils/common/Translator";
import SearchIcon from "@/components/icons/navBarIcons/SearchIcon.vue";

let value = defineModel();

let props = defineProps({
  id: {
    required: true,
    type: String
  }
})

function focusSearchInput() {
  document.getElementById(props.id)?.focus();
}
</script>

<template>
  <div class="tw-mx-2 tw-my-2">
    <div class="tw-relative tw-leading-tight">
      <span class="tw-absolute tw-inset-y-0 tw-left-0 tw-flex tw-justify-center tw-items-center tw-pl-2" @click="focusSearchInput">
            <SearchIcon class="tw-size-5"/>
      </span>
      <input
        class="tw-border-solid tw-border-[1.5px] tw-border-gray-300 tw-bg-[#F8F9FA] tw-shadow tw-appearance-none tw-rounded tw-w-full tw-py-1.5 tw-pl-10 tw-text-gray-700
          focus:tw-shadow-outline focus:tw-ring-0 focus:tw-outline-none focus:tw-border-primary-light dark:focus:tw-border-primary-dark focus:hover:tw-border-primary-light dark:focus:hover:tw-border-primary-dark
          dark:tw-bg-[#383838] hover:tw-border-gray-700 dark:hover:tw-border-gray-500 dark:hover:tw-bg-[#383838] dark:tw-text-white dark:tw-placeholder-gray-300"
        autocomplete="off"
        :id="id" type="text" :placeholder="Translator.translateId('search')" v-model="value">
    </div>
  </div>
</template>
<style scoped>
</style>
